import React, { memo, MouseEvent, useCallback, useMemo } from 'react';
import {
  CalendarLanguage,
  CalendarView,
  getDaysInMonth,
  getWeekInMonth,
} from '../../../../utils/CalendarUtils';
import { getTwoNumbersIfNotTen } from '../../../../utils/ParsingUtils';
import { CalendarEventProps } from '../../../calendarEvent/CalendarEvent';
import CalendarMonthDay from '../calendarMonthDay/CalendarMonthDay';
import './CalendarDays.scss';
const rootClassName = 'calendar-days';

interface CalendarDaysProps {
  visao: CalendarView;
  pocket?: boolean;
  referencia: Date;
  disabledNextMonth?: boolean;
  disabledPrevMonth?: boolean;
  eventos?: Map<string, CalendarEventProps[]>;
  language: CalendarLanguage;
  highlightWeekends?: boolean;
  loading?: boolean;
  showAddButton?: boolean;
  disabledPrevAddButton?: boolean;
  onAddButtonClick?: (
    day: Date,
    evt: MouseEvent<HTMLButtonElement | HTMLDivElement>
  ) => void;
  showPlusIcon?: boolean;
  onPlusButtonClick?: (
    day: Date,
    evt: MouseEvent<HTMLButtonElement | HTMLDivElement>
  ) => void;
  onDateClick?: (
    day: Date,
    evt: MouseEvent<HTMLButtonElement | HTMLDivElement>
  ) => void;
}
function CalendarDays(props: CalendarDaysProps) {
  const today = useMemo(() => {
    return new Date();
  }, []);

  const days = useMemo(() => {
    return props.visao === CalendarView.Semanal
      ? getWeekInMonth(props.referencia)
      : getDaysInMonth(props.referencia);
  }, [props.referencia, props.visao]);

  const disabledDay = useCallback(
    (date: Date) => {
      if (
        props.disabledPrevMonth &&
        (date.getFullYear() < props.referencia.getFullYear() ||
          date.getMonth() < props.referencia.getMonth())
      ) {
        return true;
      }
      if (
        props.disabledNextMonth &&
        (date.getFullYear() > props.referencia.getFullYear() ||
          date.getMonth() > props.referencia.getMonth())
      ) {
        return true;
      }
      return false;
    },
    [props.referencia, props.disabledNextMonth, props.disabledPrevMonth]
  );

  return (
    <div className={rootClassName}>
      {days.map((d) => {
        const k = `${d.getFullYear()}${getTwoNumbersIfNotTen(
          d.getMonth() + 1
        )}${getTwoNumbersIfNotTen(d.getDate())}`;
        const eventos = props.eventos?.get(k);

        return (
          <CalendarMonthDay
            pocket={props.pocket}
            language={props.language}
            key={d.getTime()}
            day={d}
            eventos={eventos}
            isToday={
              d.getDate() === today.getDate() &&
              d.getMonth() === today.getMonth() &&
              d.getFullYear() === today.getFullYear()
            }
            disabled={disabledDay(d) || props.loading}
            disabledPrevAddButton={props.disabledPrevAddButton}
            showAddButton={props.showAddButton}
            onAddButtonClick={props.onAddButtonClick}
            showPlusIcon={props.showPlusIcon}
            onPlusButtonClick={props.onPlusButtonClick}
            onDateClick={props.onDateClick}
            highlightWeekends={props.highlightWeekends}
          />
        );
      })}
    </div>
  );
}

export default memo(CalendarDays);
